import { createFeatureSelector, createSelector } from '@ngrx/store';

import { organizationFeatureKey, State } from '../reducers/organization.reducer';

export const selectOrganizationFeature = createFeatureSelector<State>(organizationFeatureKey);

export const selectFarmAlertsAutoSubscribe = createSelector(
  selectOrganizationFeature,
  (state: State) => state.farmAlertsEnabled && state.farmAlertsAutoSubscribe
);

export const selectSaleInformationEnabled = createSelector(
  selectOrganizationFeature,
  (state: State) => state.saleInformationEnabled
);

export const selectTransactionHistoryEnabled = createSelector(
  selectOrganizationFeature,
  (state: State) => state.transactionHistoryEnabled
);

export const selectFarmAlertsEnabled = createSelector(
  selectOrganizationFeature,
  (state: State) => state.farmAlertsEnabled
);

export const selectTurnoverRateEnabled = createSelector(
  selectOrganizationFeature,
  (state: State) => state.turnoverRateEnabled
);

export const selectAlternateAppIconName = createSelector(
  selectOrganizationFeature,
  (state: State) => state.alternateAppIconName
);

export const selectAlternateAppIconPreviewUrl = createSelector(
  selectOrganizationFeature,
  (state: State) => state.alternateAppIconPreviewUrl
);

export const selectApplicationName = createSelector(selectOrganizationFeature, (state: State) => state.applicationName);
